import React, { Component, createElement, Fragment } from 'react';
import { connect } from 'react-redux';
import { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { actions, services } from '@comall-backend-builder/core';
import { get } from 'lodash';

import { errorHandle } from '../../services';

const api = services.api;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

class categoryFilterAttrTable extends Component<CategoryFilterAttrTableProps> {
    constructor(props: CategoryFilterAttrTableProps) {
        super(props);
        this.state = {
            selectedSkus: [],
        };
        this.onAdd = this.onAdd.bind(this);
        this.onDeleteBatch = this.onDeleteBatch.bind(this);
        this.onDeleteAll = this.onDeleteAll.bind(this);
    }

    onAdd(attr_code: string, attr_value_codes: string[]) {
        const { params, entity } = this.props;
        if (!params || !params.categoryId) return;

        api.post(
            { attr_code, attr_value_codes },
            { apiPath: `/display_category/${params.categoryId}/filter_attr` }
        )
            .then(() => {
                // 列表数据刷新
                entity.search({
                    ...entity.params,
                    ...entity.filters,
                });
            })
            .catch(errorHandle);
    }

    onDeleteBatch() {
        const { selectedRowKeys, entity, params } = this.props;

        entity.delete(
            {
                ids: selectedRowKeys,
                type: 'batch',
            },
            {
                action: actions.searchAction(entity, { ...params }),
            }
        );
    }

    onDeleteAll() {
        const { entity, params } = this.props;

        entity.delete(
            {
                type: 'all',
            },
            {
                action: actions.searchAction(entity, { ...params }),
            }
        );
    }

    renderControllers() {
        const layoutProps = {
            component: 'GridLayout',
            items: [
                {
                    component: 'AttributeOptionSelector',
                    onSelect: this.onAdd,
                    span: 2,
                },
                {
                    component: 'Button',
                    text: '批量删除',
                    type: 'primary',
                    span: 2,
                    style: { marginBottom: '20px' },
                    onClick: this.onDeleteBatch,
                },
                {
                    component: 'Button',
                    text: '全部删除',
                    type: 'primary',
                    span: 2,
                    style: { marginBottom: '20px' },
                    onClick: this.onDeleteAll,
                },
            ],
        };
        return createElement(ComponentsManager.get('GridLayout'), layoutProps);
    }

    renderTable() {
        const { entity, componentId } = this.props;
        const tableProps = {
            entity,
            componentId,
            rowKey: 'id',
            loadFirstPage: true,
            rowSelection: {
                onChange() {},
            },
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            columns: [
                {
                    property: 'attrName',
                    modifiable: false,
                },
                {
                    property: 'attrOptionValue',
                    modifiable: false,
                },
                {
                    property: 'sequence',
                },
            ],
            actionColumn: {
                title: '操作',
                width: 230,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        text: '删除',
                        type: 'delete',
                        config: {
                            type: 'link',
                            tooltip: null,
                            title: '确定删除该关联吗?',
                            okText: '确定',
                            cancelText: '取消',
                        },
                    },
                    {
                        text: '编辑',
                        type: 'modify',
                        config: {
                            type: 'link',
                            tooltip: null,
                            title: '确定删除该关联吗?',
                            okText: '确定',
                            cancelText: '取消',
                        },
                    },
                    {
                        type: 'component',
                        component: 'AttributeSortingPage',
                    },
                    {
                        type: 'modifyConfirm',
                        text: '保存',
                        icon: '',
                        config: {
                            type: 'link',
                            tooltip: '保存',
                        },
                    },
                    {
                        type: 'modifyCancel',
                        text: '取消',
                        icon: '',
                        config: {
                            type: 'link',
                            tooltip: '取消',
                        },
                    },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    render() {
        return (
            <Fragment>
                {this.renderControllers()}
                {this.renderTable()}
            </Fragment>
        );
    }
}

function mapStateTopProps(state: any, props: any) {
    const { componentId } = props;
    const component = state.components[componentId];
    const componentState = {
        selectedRowKeys: get(component, 'selectedRowKeys'),
    };
    return componentState;
}

export const CategoryFilterAttrTable = connect(mapStateTopProps)(categoryFilterAttrTable);
